module.exports = __webpack_public_path__ + "img/cable.9c1388a6.jpg";